import Jigglypuff from './Jigglypuff';

export default Jigglypuff;



/** WEBPACK FOOTER **
 ** ./source/039-jigglypuff/index.js
 **/